
import { i18nText } from '@/locales';
import { RouterNameEnum } from "@/router/router.types"
export const StudiosRoutes = [
    {
        path: "/studios",
        redirect: "studios/index",
        component: (): any => import("@/UI/layouts/MainLayout.vue"),
        meta: { auth: true, alias: RouterNameEnum.Salons },
        children: [
            {
                path: "index/:Studio",
                component: (): any => import("@/UI/pages/salons/pages/Index.vue"),
                name: RouterNameEnum.Salons,
                meta: {
                    alias: RouterNameEnum.Salons,
                    title: "",
                    breadcrumb: [
                        { name: i18nText("Филиалы") }
                    ],
                    props: {
                        source: {
                            root: "salons",
                            name: "salons",
                            items: "salons",
                            item: "salon",
                            routePage: RouterNameEnum.SalonsPage,
                        },
                    },
                },
            },
            {
                path: "index/:Studio/page/:page/:total/:filter",
                component: (): any => import("@/UI/pages/salons/pages/Index.vue"),
                name: RouterNameEnum.SalonsPage,
                meta: {
                    title: "",
                    breadcrumb: [
                        { name: i18nText("Филиалы") }
                    ],
                    alias: RouterNameEnum.Salons,
                    props: {
                        source: {
                            root: "salons",
                            name: "salons",
                            items: "salons",
                            item: "salon",
                            routePage: RouterNameEnum.SalonsPage,
                        },
                    },
                },
            },
            {
                path: "creation",
                meta: {
                    alias: RouterNameEnum.Salons,
                    title: "",
                    breadcrumb: [
                        { name: i18nText("Филиалы"), link: 'Salons' },
                        { name: i18nText("Создание студии") }
                    ],
                },
                name: RouterNameEnum.SalonCreation,
                component: (): any => import("@/UI/pages/salons/pages/CreateStudio.vue"),
            },
            {
                path: ":id",
                redirect: "/studios/:id/general",
                name: RouterNameEnum.SalonDetail,
                meta: {
                    alias: RouterNameEnum.Salons,
                    title: "",
                    breadcrumb: [
                        { name: i18nText("Детальная") }
                    ],
                },
                component: (): any => import("@/UI/pages/salons/SalonDetail.vue"),
                children: [
                    {
                        path: "general",
                        name: RouterNameEnum.SalonDetailCommon,
                        meta: {
                            alias: RouterNameEnum.Salons,
                            title: "",
                            breadcrumb: [
                                { name: i18nText("Филиалы"), link: 'Salons', userRoleRoute: 1 },
                                { name: i18nText("Детальная") }
                            ],
                            props: {
                                source: {
                                    root: "salons",
                                    name: "salons",
                                    items: "salons",
                                    item: "salon",
                                    routePage: RouterNameEnum.SalonDetailCommon,
                                },
                            },
                        },
                        component: (): any => import("@/UI/components/salons/SalonGeneral.vue"),
                    },
                    {
                        path: 'finances/page/:page/:total/:filter/:sorted',
                        name: RouterNameEnum.SalonDetailFinancePage,
                        component: ():any => import('@/UI/components/salons/SalonsFinance.vue'),
                        meta : {
                            alias: RouterNameEnum.Salons,
                            title: "",
                            breadcrumb: [
                                { name: i18nText("Филиалы"), link: 'Salons', userRoleRoute: 1 },
                                { name: i18nText("Финансы") }
                            ],
                            props: {
                                source: {
                                    root: "financeOperations",
                                    name: "financeOperations",
                                    items: "items",
                                    item: "item",
                                    routePage: RouterNameEnum.SalonDetailFinancePage,
                                },
                            },
                        }
                    },
                    {
                        path: "clients/page/:page/:total/:filter/:sorted",
                        component: (): any => import("@/UI/components/salons/SalonClients.vue"),
                        name: RouterNameEnum.SalonDetailClientsPage,
                        meta : {
                            alias: RouterNameEnum.Salons,
                            title: "",
                            breadcrumb: [
                                { name: i18nText("Филиалы"), link: 'Salons', userRoleRoute: 1 },
                                { name: i18nText("Клиенты") }
                            ],
                            props: {
                                source: {
                                    root: "clients",
                                    name: "clients",
                                    items: "clients",
                                    item: "client",
                                    routePage: RouterNameEnum.SalonDetailClientsPage,
                                },
                            },
                        },
                    },
                    {
                        path: "workers/page/:page/:total/:filter/:sorted",
                        name: RouterNameEnum.SalonDetailWorkers,
                        meta: {
                            alias: RouterNameEnum.Salons,
                            title: "",
                            breadcrumb: [
                                { name: i18nText("Филиалы"), link: 'Salons', userRoleRoute: 1 },
                                { name: i18nText("Сотрудники") }
                            ],
                            props: {
                                source: {
                                    root: "workers",
                                    name: "workers",
                                    items: "workers",
                                    item: "worker",
                                    routePage: RouterNameEnum.SalonDetailWorkers,
                                },
                            },
                        },
                        component: (): any => import("@/UI/components/salons/SalonWorkers.vue"),
                    },
                    {
                        path: "photo",
                        name: RouterNameEnum.SalonDetailPhoto,
                        meta: {
                            alias: RouterNameEnum.Salons,
                            title: "",
                            breadcrumb: [
                                { name: i18nText("Филиалы"), link: 'Salons', userRoleRoute: 1 },
                                { name: i18nText("Фотографии") }
                            ],
                        },
                        component: (): any => import("@/UI/components/salons/SalonPhoto.vue"),
                    },
                    {
                        path: "documents",
                        name: RouterNameEnum.SalonDetailDocs,
                        meta: {
                            alias: RouterNameEnum.Salons,
                            title: "",
                            breadcrumb: [
                                { name: i18nText("Филиалы"), link: 'Salons', userRoleRoute: 1 },
                                { name: i18nText("Документы") }
                            ],
                        },
                        component: (): any => import("@/UI/components/salons/SalonDocs.vue"),
                    },
                    {
                        path: "accesses",
                        name: RouterNameEnum.SalonDetailAllow,
                        meta: {
                            alias: RouterNameEnum.Salons,
                            title: "",
                            breadcrumb: [
                                { name: i18nText("Филиалы"), link: 'Salons', userRoleRoute: 1 },
                                { name: i18nText("Доступы") }
                            ],
                        },
                        component: (): any => import("@/UI/components/salons/SalonAccesses.vue"),
                    },
                ],
            },
        ],
    },
];
